export default {"src":"/_next/static/media/11-300x234.d7a9100a.svg","height":27,"width":113,"blurWidth":0,"blurHeight":0};